let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1hT87")).then(() => parcelRequire('38vJk'));